import { Footer } from '@cs-cms/ui';
import { CpsGrid } from '../../../../../packages/ui/src/grid/CpsGrid';
import CpsPage from '../../../../../packages/ui/src/pages/CpsPage';
import TopBar from '../../../../../packages/ui/src/topBar/TopBar';
import { RtDocumentForm } from '@features/upload-editable-fields';

export const DocumentWorkspace: React.FC = () => {
  return (
    <CpsPage>
      <TopBar />
      <CpsGrid />
      <RtDocumentForm />
      <Footer />
    </CpsPage>
  );
};
